import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, RadioGroup, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const CustodyStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [intro, setIntro] = useState<string>('Begge forældre skal som udgangspunkt møde personligt op.');

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.custody).then(c => {
      if (c?.body && c.body.length > 0) {setIntro(c.body[0]);}
    });
  }, []);

  const handleNext = () => {
    if (selfServiceData.custodyBothPresent !== undefined) {goNext();}
  };

  return (
    <StepContainer title="Forældremyndighed">
      <InfoBox type="info"><p>{intro}</p></InfoBox>
      <RadioGroup
        name="custodyBothPresent"
        options={[
          { value: 'true', label: 'Ja, begge møder personligt op' },
          { value: 'false', label: 'Nej, kun én møder – samtykke indhentes' }
        ]}
        value={selfServiceData.custodyBothPresent === undefined ? '' : String(selfServiceData.custodyBothPresent)}
        onChange={(v) => updateSelfServiceData('custodyBothPresent', v === 'true')}
        legend="Forældremyndighed"
        required
      />
      <NavigationButtons onBack={goBack} onNext={handleNext} nextDisabled={selfServiceData.custodyBothPresent === undefined} />
    </StepContainer>
  );
};

export default CustodyStep;

